var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.583 4.41667L13.2905 5.70917L15.6555 8.08333H6.33301V9.91667H15.6555L13.2905 12.2817L14.583 13.5833L19.1663 9M2.66634 2.58333H9.99967V0.75H2.66634C1.65801 0.75 0.833008 1.575 0.833008 2.58333V15.4167C0.833008 16.425 1.65801 17.25 2.66634 17.25H9.99967V15.4167H2.66634V2.58333Z",
    fill: "#3A6AB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f174717a4c31d93e786bb31d1b036272.svg";
export { ForwardRef as ReactComponent };